module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "become-affiliate-status-modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "affiliate-pending-modal"
    }
  }, [_c('div', {
    class: ['modal-dialog', {
      'zh-style': _vm.lang === 'zh'
    }],
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-close"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "notice"
  }, [(_vm.commissionApplyStatus === 'pending') ? [_vm._v(_vm._s(_vm.$t('pendingNotice')))] : _vm._e(), _vm._v(" "), (_vm.commissionApplyStatus === 'cancelled') ? [_vm._v(_vm._s(_vm.$t('cancelledNotice')))] : _vm._e(), _vm._v(" "), (_vm.commissionApplyStatus === 'complete') ? [_vm._v(_vm._s(_vm.$t('completeNotice')))] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "email"
  }, [_vm._v("iplexservice@gmail.com")]), _vm._v(" .")], 2), _vm._v(" "), _c('button', {
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('sure')))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-beba2d1e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/becomeAffiliate/statusModal/Index.vue
// module id = 1386
// module chunks = 1